module.exports = __webpack_public_path__ + "dist/assets/img/UI.62c98c77.svg";